module.exports = __webpack_public_path__ + "static/media/foot-left-side.8dcc520e.png";